(function () {
  'use strict';

  if (window.__sculpdComplementaryQuickAdd) return;
  window.__sculpdComplementaryQuickAdd = true;

  var SCOPE = 'product-recommendations[data-intent="complementary"]';
  var TRIGGER = '.js-quick-add-form, .js-modal-open-quick-add';
  var HOLDER = '#QuickAddHolder';

  var pending = null;

  function homeRoot() {
    return (window.theme && theme.routes && theme.routes.home) || '';
  }

  function fetchVariants(handle) {
    var url = (homeRoot() + '/products/' + handle + '.js').replace('//', '/');

    return fetch(url)
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (product) {
        return (product && product.variants) || [];
      })
      .catch(function () {
        return [];
      });
  }

  function applyHideSoldVariants(container, variants) {
    if (!container || !variants.length) return;

    function selections() {
      var selected = {};

      for (var i = 1; i <= 3; i++) {
        var input = container.querySelector(
          '[data-index="option' + i + '"] input[type="radio"]:checked'
        );
        if (input) selected['option' + i] = input.value;
      }

      return selected;
    }

    function matching(optionNumber, value, selected) {
      return variants.filter(function (variant) {
        for (var i = 1; i <= optionNumber; i++) {
          var variantValue = variant['option' + i];
          var selectedValue = i === optionNumber ? value : selected['option' + i];
          if (selectedValue && variantValue !== selectedValue) return false;
        }
        return true;
      });
    }

    function process() {
      var selected = selections();

      for (var n = 1; n <= 3; n++) {
        var wrapper = container.querySelector('[data-index="option' + n + '"]');
        if (!wrapper) continue;

        wrapper.querySelectorAll('[data-value]').forEach(function (option) {
          var matches = matching(n, option.dataset.value, selected);
          var hide =
            matches.length > 0 &&
            matches.every(function (variant) {
              return !variant.available;
            });

          option.style.display = hide ? 'none' : '';
          option.style.visibility = hide ? 'hidden' : '';
        });
      }
    }

    process();

    container.addEventListener('change', function (event) {
      if (
        event.target &&
        event.target.matches &&
        event.target.matches('[data-index^="option"] input[type="radio"]')
      ) {
        process();
      }
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest && event.target.closest(TRIGGER);
      if (!trigger) return;

      var scope = trigger.closest(SCOPE);
      if (!scope || scope.dataset.hideSoldVariants !== 'true') return;

      var card = trigger.closest('.grid-product');
      var handle = card && card.getAttribute('data-product-handle');
      if (!handle) return;

      pending = { handle: handle, variants: fetchVariants(handle) };
    },
    true
  );

  document.addEventListener('quickadd:loaded', function (event) {
    var detail = event.detail || {};
    if (!pending || detail.handle !== pending.handle) return;

    var holder = document.querySelector(HOLDER);
    var variants = pending.variants;
    pending = null;

    variants.then(function (list) {
      applyHideSoldVariants(holder, list);
    });
  });
})();
